module.exports = __webpack_public_path__ + "static/doswiadczony-deweloper-0fec13a21b7c2cfd93b09584cf69cb3f.jpg";